// Domain configuration
const DOMAINS = {
  PRODUCTION: {
    MAIN: 'camatsteamracing.com',
    API: 'https://camatsteamracing.com'
  },
  DEVELOPMENT: {
    MAIN: 'localhost',
    API: 'http://localhost:5000'
  }
};

// Helper function to get current domain configuration
export const getDomainConfig = () => {
  const isLocalhost = window.location.hostname === 'localhost';
  return isLocalhost ? DOMAINS.DEVELOPMENT : DOMAINS.PRODUCTION;
};

export default DOMAINS; 